import { FormatNumberOptions } from 'react-intl';

import { ComparisonChartKey } from './hooks/useComparisonChartData';
import { basisPointsToPercent } from '../../../deals/DealStages/EventActionCards/utils';

export const comparisonChartConfig: Record<
  ComparisonChartKey,
  {
    chart: 'Pie' | 'Bar';
    avgLabel: string;
    valueFormater?: (value: number) => number;
    valueFormatOptions?: FormatNumberOptions & {
      prepareNumber?: (value: number) => number;
    };
    yAxisLabelPadding?: number;
  }
> = {
  UPB: {
    chart: 'Bar',
    avgLabel: 'AVERAGE',
    yAxisLabelPadding: 70,
    valueFormater: (value) => value / 100,
    valueFormatOptions: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    },
  },
  ['Bid PX']: {
    chart: 'Bar',
    avgLabel: 'AVERAGE',
    yAxisLabelPadding: 40,
    valueFormater: (value) => Number(basisPointsToPercent(value)),
    valueFormatOptions: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      prepareNumber: (num) => num / 100,
    },
  },
  ['# Loans']: {
    chart: 'Bar',
    avgLabel: 'AVERAGE',
    yAxisLabelPadding: 40,
  },
  ['C Balance']: {
    chart: 'Pie',
    avgLabel: 'AVERAGE',
    yAxisLabelPadding: 95,
    valueFormatOptions: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      prepareNumber: (num) => num / 100,
    },
  },
  ['O Balance']: {
    chart: 'Pie',
    avgLabel: 'AVERAGE',
    yAxisLabelPadding: 100,
    valueFormatOptions: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      prepareNumber: (num) => num / 100,
    },
  },
  WALA: {
    chart: 'Pie',
    yAxisLabelPadding: 40,
    avgLabel: 'AVERAGE',
  },
  WAM: {
    chart: 'Bar',
    yAxisLabelPadding: 40,
    avgLabel: 'AVERAGE',
  },
  GWAC: {
    chart: 'Bar',
    yAxisLabelPadding: 40,
    avgLabel: 'AVERAGE',
    valueFormatOptions: {
      style: 'percent',
      prepareNumber: (num) => num * 1000,
    },
  },
  FICO: {
    chart: 'Bar',
    yAxisLabelPadding: 40,
    avgLabel: 'AVERAGE',
  },
  LTV: {
    chart: 'Pie',
    yAxisLabelPadding: 40,
    avgLabel: 'AVERAGE',
    valueFormatOptions: {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      prepareNumber: (num) => num,
    },
  },
  DTI: {
    chart: 'Pie',
    yAxisLabelPadding: 40,
    avgLabel: 'AVERAGE',
    valueFormatOptions: {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      prepareNumber: (num) => num,
    },
  },
};

export const getArrayAverageNum = (arr: number[]) => {
  const sum = arr.reduce((acc: number, b: number) => acc + b, 0);
  return sum / arr.length;
};
